// extracted by mini-css-extract-plugin
module.exports = {"custom_modal":"index_custom_modal__4ZkbQ","title__wrapper":"index_title__wrapper__N4RQE","warning__icon":"index_warning__icon__RVkKp"};